import { FC, useEffect, useState } from 'react';
import CloseIcon from './icons/CloseIcon';
import AddToCalendar from "@culturehq/add-to-calendar";
interface Event {
	id: number;
	title: string;
	date?: string | null; // Make date optional and allow it to be null
	description: string;
	link: string;
	images: { [key: string]: string };
	start_time?: string | null;
	end_time?: string | null;
}

interface InfoPopupProps {
	event: Event;
	onClose: () => void;
}

const InfoPopup: FC<InfoPopupProps> = ({ event, onClose }) => {
	const hasImages = Object.values(event.images).some(url => url !== '');

	const [isVisible, setIsVisible] = useState(false);

	// let startsAt, endsAt;

	let startsAt: string | null = null;
	let endsAt: string | null = null;
	let formattedDate: string | null = null;

	if (event.date) {
		// If date is defined, process the start and end times
		const eventDate = new Date(event.date);

		// Format the date as "Wednesday, August 21"
		formattedDate = eventDate.toLocaleDateString('en-US', {
			weekday: 'long',
			month: 'long',
			day: 'numeric',
		});

		if (event.start_time) {
			startsAt = new Date(`${event.date}T${event.start_time}`).toISOString();
		} else {
			// Default to the date without time if start_time is undefined
			startsAt = new Date(event.date).toISOString();
		}

		if (event.end_time) {
			endsAt = new Date(`${event.date}T${event.end_time}`).toISOString();
		} else {
			// Default to 1 hour after startsAt if end_time is undefined
			endsAt = new Date(new Date(startsAt).getTime() + 60 * 60 * 1000).toISOString();
		}
	} else {
		// If date is not defined, log an error and avoid further processing
		console.error('Event date is not defined');
		startsAt = null;
		endsAt = null;
	}

	useEffect(() => {
		setIsVisible(true);
		return () => setIsVisible(false); // Cleanup function
	}, []);

	const handleClose = () => {
		setIsVisible(false);
		setTimeout(onClose, 300); // Delay calling onClose to allow transition to finish
	};

	return (
		<div className={`fsdpe-calendar-wrapper__popup ${isVisible ? 'active' : ''}`}>
			<div className="fsdpe-calendar-wrapper__popup__content">
				<div className={"fsdpe-calendar-wrapper__popup__content__data"}>
					<h2>{event.title}</h2>

					<div style={{
						display: 'block',
						marginBottom: '10px'
					}}>
						<span>{formattedDate || 'Date not provided'}</span>
						<span>, </span>
						<span>{event.start_time || 'No start time provided'}</span>
					</div>

					<p style={{
						display: 'block',
						marginBottom: '10px'
					}}>{event.description}</p>
					<p>
						<a href={event.link}
						   style={{
							   display: 'block',
							   marginBottom: '16px'
						   }}
						>Read more</a>
					</p>
					<button className={"fsdpe-calendar-wrapper__popup__close"} onClick={handleClose}>
						<CloseIcon/>
					</button>
					{startsAt && (
						<AddToCalendar
							children={'Add to calendar'}
							event={{
								name: event.title,
								details: event.description,
								location: '', // Optional
								startsAt,
								endsAt,
							}}
						/>
					)}
				</div>
				<div className={"fsdpe-calendar-wrapper__popup__content__image"}>
					{hasImages && (
						<div className="image-wrapper">
							<img src={event.images.medium} alt={event.title}/>
						</div>
					)}
				</div>
			</div>
		</div>
	);
};

export default InfoPopup;

